import { DatePipe } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { KeepScrollPositionDirective } from '@shared/directives/keep-scroll-position.directive';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { BatchJobScheduleDetailComponent } from '../batch-job-schedule-detail/batch-job-schedule-detail.component';
import { BatchService } from '../batch.service';

@Component({
  selector: 'app-batch-job-schedule',
  imports: [
    TableRowDirective,
    TableModule,
    DialogModule,
    DatePipe,
    KeepScrollPositionDirective,
    BatchJobScheduleDetailComponent,
  ],
  templateUrl: './batch-job-schedule.component.html',
  styleUrl: './batch-job-schedule.component.css',
})
export class BatchJobScheduleComponent {
  batchService = inject(BatchService);
  showDetails = signal(false);

  scheduleData = computed(() =>
    this.batchService.batchJobSceduleDatasource
      .data()
      .data.filter(x => !!x.koerselsTidspunkt)
  );

  onRowSelect() {
    this.showDetails.set(true);
  }

  onHideJobDetails() {
    this.batchService.selectedBatchJobSchedule.set(undefined);
  }
}
